import Swal from "sweetalert2";

export const GOOGLE_TOKEN_EXPIRED_CODE = "GOOGLE_TOKEN_EXPIRED";
export const GOOGLE_CALENDAR_SYNC_HEADER = "x-google-calendar-sync";
export const GOOGLE_CALENDAR_SYNC_EXPIRED = "expired";

export function isGoogleCalendarTokenExpiredError(error) {
  return (
    error?.response?.status === 401 &&
    error?.response?.data?.code === GOOGLE_TOKEN_EXPIRED_CODE
  );
}

export function isGoogleCalendarSyncExpired(response) {
  const value = response?.headers?.[GOOGLE_CALENDAR_SYNC_HEADER];
  return String(value || "").toLowerCase() === GOOGLE_CALENDAR_SYNC_EXPIRED;
}

/**
 * Muestra un aviso y opción de ir al flujo OAuth de Google Calendar.
 * Debe iniciar sesión en el backoffice la cuenta que coincide con EMAIL_CALENDAR (admin de calendario).
 */
export function promptReconnectGoogleCalendar(history) {
  return Swal.fire({
    icon: "warning",
    title: "Google Calendar desconectado",
    text:
      "La sesión de Google Calendar del administrador ha caducado o fue revocada. Reconecta la cuenta usada para los calendarios compartidos (tonitorres.life@gmail.com).",
    confirmButtonText: "Reconectar Google",
    showCancelButton: true,
    cancelButtonText: "Cerrar",
  }).then((r) => {
    if (r.isConfirmed && history) history.push("/calendar?refresh=true");
  });
}
